import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import Dashboard from "@/pages/Dashboard";
import LeadsBoard from "@/pages/LeadsBoard";
import Playbook from "@/pages/Playbook";
import Commissions from "@/pages/Commissions";
import Settings from "@/pages/Settings";
import Users from "@/pages/Users";
import Arena from "@/pages/Arena";
import PublicProposal from "@/pages/PublicProposal";

function AppShell({ children }) {
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/p/:token" element={<PublicProposal />} />
            <Route
              path="/change-password"
              element={
                <ProtectedRoute>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <Dashboard />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/leads"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <LeadsBoard />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/playbook"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <Playbook />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/commissions"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <Commissions />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/arena"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <Arena />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute adminOnly>
                  <AppShell>
                    <Users />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute adminOnly>
                  <AppShell>
                    <Settings />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#141B1E",
            border: "1px solid #202B30",
            color: "#EFF4F2",
            borderRadius: "3px",
          },
        }}
      />
    </div>
  );
}
